import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { logout } from "./features/logoutSlice";

import createApplicationReducer from "./features/newApplicationSlice";
import applicationReducer from "./features/applicationSlice";
import agentReducer from "./features/agentSlice";
import leadsReducer from "./features/adminLeadSlice";
import historyReducer from "./features/historySlice";
import globalCountriesReducer from "./features/countriesSlice";
import checklistReducer from "./features/checklistSlice";
import dashboardReducer from "./features/adminDashboardSlice";
import dashboardSummaryReducer from "./features/agentDashboardSlice";
import employeeProfileReducer from "./features/employeeProfileSlice";
import applicationLogReducer from "./features/applicationLogSlice";
import clientChecklistReducer from "./features/clientChecklistSlice";
import bankDetailsReducer from "./features/bankDetailSlice";
import bankDetailsByCountryReducer from "./features/clientBankDetail";
import notificationsReducer from "./features/notificationSlice";
import invoiceReducer from "./features/invoiceSlice";
import paymentReducer from "./features/paymentSlice";
import filterReducer from "./features/filterSlice";
import userReducer from "./features/userSlice";

// Combine all reducers
const appReducer = combineReducers({
  user: userReducer,
  filters: filterReducer,
  bankDetailsByCountry: bankDetailsByCountryReducer,
  createApplication: createApplicationReducer,
  dashboardSummary: dashboardSummaryReducer,
  employeeProfile: employeeProfileReducer,
  clientChecklist: clientChecklistReducer,
  globalCountries: globalCountriesReducer,
  notifications: notificationsReducer,
  applications: applicationLogReducer,
  application: applicationReducer,
  invoices: invoiceReducer,
  bankDetails: bankDetailsReducer,
  dashboard: dashboardReducer,
  checklist: checklistReducer,
  payment: paymentReducer,
  history: historyReducer,
  agents: agentReducer,
  leads: leadsReducer,
});

// Reset state on logout
const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    state = undefined; // Clear all slices
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
